/*
  Project: MBrace
  Author: Rafal
 */
const $ = window.jQuery;
window.$ = require('jquery');

function initMenu(afterToggle = null) {
  const $menu = $('.c-main-nav--toggleable');
  const $menuToggle = $('#menu-toggle');
  const menuOpenClass = 'navbar-menu-open';
  const btnToggleCloseClass = 'navbar-toggle-close';

  $menuToggle.click(e => {
    e.preventDefault();

    $menuToggle.toggleClass(btnToggleCloseClass);
    $menu.slideToggle(300, () => {
      $menu.toggleClass(menuOpenClass);
      $menu.removeAttr('style');

      if (afterToggle) {
        afterToggle();
      }
    });
  });
}

/* eslint-disable */
function initForm() {
    const $form = $('.c-contact-form');
    $form.submit(e => {
        e.preventDefault();
        const data = $form.serialize();
        const posting = $.post('post.php', data);
        
        posting.done(function( response ) {
            $form.hide();
            const content = response;
            $('.c-form-output').empty().append( content );
          });
    });
}
/* eslint-enable */

$(() => {
  initMenu();
  initForm();
});



// WEBPACK FOOTER //
// ./src/scripts/app.js